import { Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';

export type TListOfBrokenRulesByCardDataTableData = {
  primaryKey: string | number,
  ruleId: string,
  description: string,
  startDate: string,
  endDate: string,
  performedValue: string,
  referenceValue: string,
  percentPlus: string,
  riskLevel: string,
  type: string,
  traderId: string,
  trader: string,
  mcc: string,
  countryCode: string,
  acquirerBank: string,
};

type Props = {
  isLoading: boolean | undefined,
};

const columnHelper = createColumnHelper<TListOfBrokenRulesByCardDataTableData>();

export function getListOfBrokenRulesByCardDataTableColumns({ isLoading }: Props) {
  return [
    columnHelper.accessor('ruleId', {
      id: 'ruleId',
      header: 'Id Règle',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            {props.getValue()}
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('description', {
      id: 'description',
      header: 'Description',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('startDate', {
      id: 'startDate',
      header: 'Date Début',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('performedValue', {
      id: 'performedValue',
      header: 'Valeur Effectuée',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('referenceValue', {
      id: 'referenceValue',
      header: 'Valeur Référence',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('percentPlus', {
      id: 'percentPlus',
      header: '%Plus',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('riskLevel', {
      id: 'riskLevel',
      header: 'Niveau Risque',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('type', {
      id: 'type',
      header: 'Type',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('traderId', {
      id: 'traderId',
      header: 'ID Commerçant',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('trader', {
      id: 'trader',
      header: 'Commerçant',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('mcc', {
      id: 'mcc',
      header: 'Mcc',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('countryCode', {
      id: 'countryCode',
      header: 'Pays',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('acquirerBank', {
      id: 'acquirerBank',
      header: 'Acq.Banq',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    
  ];
}
